import { render, staticRenderFns } from "./ProductToItemSelect.vue?vue&type=template&id=85d5d2a0&scoped=true&"
import script from "./ProductToItemSelect.vue?vue&type=script&lang=js&"
export * from "./ProductToItemSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductToItemSelect.vue?vue&type=style&index=0&id=85d5d2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5d2a0",
  null
  
)

export default component.exports